<template>
  <div v-if="is_load">
    <section  class="section">
      <div class="content_background_color_blue2">
      <div class="form-group ">
        <label class="text-white m-3">Выберите категорию</label>
        <select class="form-control" @change="loadItems" v-model="choose_category" >
          <option value="0">Все категории</option>
          <option v-for="(category,category_index) in categorys"  :value="category.last_id" :key="category.last_id">{{ category.title}}</option>

        </select>


      </div>
      </div>
      <div class="col-12" v-if="items.length>0">

        <div class="col-6 col-md-3 card "  v-for="(item,item_index) in items" :key="item_index" >
          <router-link class="" :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" ><img :src="item.photos[0]" class="card-img-top" alt="..."></router-link>
          <div class="card-body">
            <router-link class=" " :to="{name: 'shop_item_id', params: {id:item.last_id }}" tag="a" > <h5 class="card-title">{{ item.title}}</h5></router-link>
            <h5 class="card-title">{{ item.price}} {{ item.currency}}</h5>
            <div class="row mb-2">
              <div class="col-3">
                <button type="button" @click="changeType(item_index,'-')" class="btn-default" v-if="count_arr['last_id_'+item.last_id]>0">-</button>
              </div>
              <div class="col-6">
                {{ item.count}}
              </div>
              <div class="col-3">
                <button type="button" @click="changeType(item_index,'+')" class="btn-default">+</button>

              </div>
            </div>

             <a href="#" class="btn btn-danger" @click="addToCart(item_index)">В корзину</a>
          </div>
        </div>

      </div>
    </section>
    <section style="display:none;" class="section section section-shaped my-0 overflow-hidden content_background_color_blue2">
      <div class="shape shape-style-1 bg-gradient-warning ">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>

      </div>

      <div class="container py-0 ">
        <div class="row row-grid mb-5 align-items-center">
          <div class="d-flex px-3">
            <div>
              <icon name="ni ni-building" size="lg" class="bg-gradient-white" color="primary" shadow
                    rounded></icon>
            </div>
            <div class="pl-4">
              <h4 class="display-3 text-white">На продажу</h4>
              <p class="text-white">Тут собраны все готовые системы, разработанные мной.</p>
              <p class="text-white"><a href="#" target="_blank" class="text-white">Отзывы</a></p>

            </div>
          </div>

          <div class="row col-md-12 mt-3">
            <div class="card col-6"  v-for="(category,category_index) in categorys" :key="category.last_id">

              <div class="card-body">
                <h5 class="card-title">{{ category.title}}</h5>
                <router-link class="btn side2 " :to="{name: 'shop_category_id', params: {id:category.last_id }}"
                >Посмотреть
                </router-link>



              </div>
            </div>


          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "../../models/Api";




var Avatar = require('vue-avatar');


export default {
  name: 'ShopCategorys',

  components: {},
  data() {
    return {
      "is_load":false,
      "categorys":[],
      "count_arr":{},
      "choose_category":0,
      "items":[],
      'item':{},
    }
  },
  mounted() {

    var app=this;

    Api.loadShopCategorys(function(data){
      //console.log('data categorys');
      //  console.log(data);
      app.categorys=data.categorys;
      app.loadItems();
      app.is_load=true;
    });

  },
  methods: {
    changeType(last_id,type){
      var app=this;
      var count_arr=app.count_arr;
      var count=parseInt(app.items[last_id].count);

      if(count>0 && type=="-"){
        count=count-1;

      }else if(type=="+"){
        count=count+1;
      }

      app.isload=false;
  //    Vue.delete(app.cart, 'last_id_'+last_id);
      app.items[last_id].count=0;
      app.items[last_id].count=count;


      app.isload=true;
    },
    changeCount(index_last_id){
      var count=1;
      var app=this;
      if(app.count_arr["last_id_"+index_last_id]>0){
        count=app.count_arr["last_id_"+index_last_id];
      }
      app.count_arr["last_id_"+index_last_id]=count;

    },
    addToCart(index_key){

      var app=this;
      app.item=app.items[index_key];

      if(app.item.count<1){
        app.item.count=1;
      }


      var item={};
      item.last_id=app.item.last_id;
      item.title=app.item.title;
      item.photos=app.item.photos;
      item.price=app.item.price;
      item.custom_price=app.item.price;
      item.currency=app.item.currency;
      item.options=app.item.options;
      item.custom_options=[];
      item.count=app.item.count;
      item.total_price=parseInt(item.price)*item.count;

    //  console.log('item add to cart');
    //  console.log(item);

      // var query_obj={};
      // if(localStorage.getItem('api_token')){
      //   query_obj.rand_code=localStorage.getItem('api_token');
      // }

      Api.addToCart(item);
      Api.syncCart();


     // app.custom_options=[];

    //  app.custom_price=parseInt(app.item.price);

    },
    loadItems(){
      var app=this;
      var current_category=app.choose_category;


      Api.loadAllItems(current_category,function(data){

      if(data.items.length>0){
        var i=0;
        var items=data.items;
        while(items[i]){

           app.count_arr["last_id_"+items[i].last_id]=1;
           items[i].count=1;

          i=i+1;
        }
      }else {
        var items=[];
      }

      app.items=items;
      });
    }




  }
};
</script>
